import moment from "moment";
import React from "react";
import { removeAllCookies } from "../../utils";
import FileSearchBar from "./../../component/file/FileSearchBar";
import CONSTANT from "./../../constant";

import { getCookie, getDateParts } from "../../utils";
import { pendingHodFiles } from "./../../actions/FileAction";
import { getVersion } from "./../../actions/MasterAction";

import "../../assets/css/homepage.css";
import SessionOut from "../../component/SessionOut/SessionOut";

import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

class PendingHodFiles extends React.Component<any, any> {
  private searchTimeout: any = null;

  constructor(props: any) {
    super(props);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    this.state = {
      page: 1,
      limit: 20,
      total: 0,
      initiatedFiles: undefined,
      pendingFiles: undefined,
      otherFiles: undefined,
      userDetail,
      sessionExpired: false,
      b_list: undefined,
      searchTerm: '', // Add search term
      isLoading: false, // Add loading state
      expandedSections: {
        myFiles: true,
      },
    };
  }

  toggleSection = (section: string) => {
    this.setState((prevState: any) => ({
      expandedSections: {
        ...prevState.expandedSections,
        [section]: !prevState.expandedSections[section],
      },
    }));
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.allFiles;

    this.loadList();

    getVersion().then((res: any) => {
      if (CONSTANT.version.web < res.web) {
        window.location.reload();
      }
    });
  }

  componentWillUnmount() {
    // Clear timeout when component unmounts
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  handleSearch = (searchTerm: string) => {
    this.setState({ searchTerm });

    // Clear existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set new timeout for debouncing (wait 500ms after user stops typing)
    this.searchTimeout = setTimeout(() => {
      this.setState({ page: 1, isLoading: true }, () => {
        this.loadList();
      });
    }, 500);
  };

  render() {
    const { page, limit, total, pendingFiles, sessionExpired, searchTerm } = this.state;

    if (sessionExpired) {
      return <SessionOut />;
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card homedob p-4 mb-4">
              <div className="row">
                <div className="col-md-6">
                  <FileSearchBar 
                    onSearch={this.handleSearch}
                    searchValue={searchTerm}
                  />
                </div>
                {/* <div className="col-md-6 text-end">
                  <Link
                    to={CONSTANT.component.userAddFile.url}
                    className="btnhomeaddf"
                  >
                    <i className="fa fa-plus-circle mr-2" />
                    Add File
                  </Link>
                </div> */}
              </div>
              <div className="row">
                <div className="col-md-12 mt-4 mb-5">
                  <div className="list-container">
                    <div className="table-container">
                      <div className="table-wrapper">
                        <table className="tablen">
                          <thead>
                            <tr className="headbg">
                              <th colSpan={8} className="tabheadtitle">
                                Files Pending for Approval
                              </th>
                            </tr>
                            {this.state.expandedSections.myFiles && (
                              <tr>
                                <th scope="col" className="text-nowrap">
                                  Comp. No.
                                </th>
                                <th scope="col" className="text-nowrap">
                                  File Number
                                </th>
                                <th scope="col">Subject</th>
                                <th scope="col" className="text-nowrap">
                                  Sent On
                                </th>
                                <th scope="col" className="text-nowrap">
                                  Submitted By
                                </th>
                                <th scope="col">Action</th>
                              </tr>
                            )}
                          </thead>
                          {this.state.expandedSections.myFiles && (
                            <tbody>
                              {(pendingFiles === undefined || this.state.isLoading) && (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    <div className="d-flex justify-content-center align-items-center py-3">
                                      <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                      </div>
                                      <span className="ml-2">Loading...</span>
                                    </div>
                                  </td>
                                </tr>
                              )}

                              {pendingFiles !== undefined &&
                                !this.state.isLoading &&
                                pendingFiles.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      {searchTerm 
                                        ? "No files match your search" 
                                        : "Couldn't find any files with you"}
                                    </td>
                                  </tr>
                                )}

                              {pendingFiles !== undefined &&
                                !this.state.isLoading &&
                                pendingFiles.map((item: any, index: number) => {
                                  const detailPageURL =
                                    CONSTANT.component.userFileDetail.url.replace(
                                      ":code",
                                      item.code
                                    );
                                  const dated = getDateParts(item.createdOn);
                                  const subjectStr =
                                    item.subject.length > 50
                                      ? item.subject.substr(0, 50) + "..."
                                      : item.subject;
                                  const sd = moment(item.createdOn); //start date
                                  const ed = moment();
                                  const diff = Math.floor(
                                    moment.duration(ed.diff(sd)).asDays()
                                  );
                                  let diffCSSClassName = "";
                                  if (diff >= 0 && diff <= 7) {
                                    diffCSSClassName = "text-primary";
                                  } else if (diff > 7 && diff <= 14) {
                                    diffCSSClassName = "text-info";
                                  } else if (diff > 14 && diff <= 21) {
                                    diffCSSClassName = "text-warning";
                                  } else {
                                    diffCSSClassName = "text-danger";
                                  }

                                  return (
                                    <tr key={index} className="c-pointer">
                                      <td
                                        className="sno"
                                        onClick={() =>
                                          this.openDetailPage(detailPageURL)
                                        }
                                      >
                                        {item.code}
                                      </td>

                                      <td
                                        onClick={() =>
                                          this.openDetailPage(detailPageURL)
                                        }
                                      >
                                        {item.fileNumber}
                                      </td>
                                      <td
                                        className="subject"
                                        title={item.subject}
                                        onClick={() =>
                                          this.openDetailPage(detailPageURL)
                                        }
                                      >
                                        {subjectStr}
                                      </td>
                                      <td
                                        onClick={() =>
                                          this.openDetailPage(detailPageURL)
                                        }
                                      >
                                        <span className="status-badge modified text-nowrap">
                                          {moment(item.createdOn).format(
                                            "YYYY-MM-DD h:mm:ss A"
                                          )}
                                        </span>
                                      </td>
                                      <td
                                        onClick={() =>
                                          this.openDetailPage(detailPageURL)
                                        }
                                      >
                                        <span className="status-badge text-nowrap">
                                          {item?.createdByName}
                                        </span>
                                      </td>
                                      <td className={diffCSSClassName}>
                                        {item?.hodApprovalStatus ===
                                          "PENDING" && (
                                          <button
                                            title="This file is saved as a draft."
                                            className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-500 ring-inset"
                                            onClick={() =>
                                              this.handleUpdateDraftStatus(
                                                item?.code
                                              )
                                            }
                                          >
                                            Click for Approval
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          )}
                        </table>
                        <div className='mt-4 p-4'>
                          {pendingFiles !== undefined && pendingFiles.length !== 0 && total > limit && (
                            <ResponsivePagination
                              activeItemClassName='Pagi-number-ac'
                              current={page}
                              maxWidth={1}
                              total={Math.ceil(total / limit)}
                              onPageChange={this.handlePageChange}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  loadList = (page: number = this.state.page, limit: number = this.state.limit) => {
    const { searchTerm } = this.state;
    this.setState({ isLoading: true }); // Set loading to true when starting request
    
    pendingHodFiles(page, limit, searchTerm).then((res: any) => {
      if (res) {
        this.setState({
          pendingFiles: res?.result?.pendingFiles,
          total: res?.result?.total || 0,
          otherFiles: res.result?.otherFiles,
          initiatedFiles: res.result?.initiatedFiles,
          isLoading: false, // Set loading to false when data is received
        });
      } else if (res == undefined) {
        this.setState(
          (prev: any) => {
            return {
              ...prev,
              sessionExpired: true,
              isLoading: false, // Set loading to false on error
            };
          },
          () => {
            setTimeout(() => {
              removeAllCookies();
              localStorage.removeItem("timer");
              this.props.history.push("/");
            }, 3000);
          }
        );
      }
    }).catch(() => {
      this.setState({ isLoading: false }); // Set loading to false on error
    });
  };

  handleUpdateDraftStatus = async (code: string) => {
    this.props.history.push({
      pathname: "/file/hod/approve",
      search: `?code=${code}`,
    });
  };

  handlePageChange = (newPage: number) => {
    this.setState({ page: newPage }, () => {
      this.loadList();
    });
  };

  openDetailPage = (url: string) => {
    this.props.history.push(url);
  };

  changePage = (e: any) => {
    const type = e.target.dataset.type;
    const page = type === "+" ? this.state.page + 1 : this.state.page - 1;
    this.setState({ page }, () => {
      this.loadList();
    });
  };
}

export default PendingHodFiles;